import {Component, Input, OnInit, OnChanges, ViewChild, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {
  AuthenticationService,
  DataService,
  LoansService,
  OperationsService,
  OptionsserviceService,
  StorageService
} from '../../_services/index';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-investmentloancontract',
  templateUrl: './investmentloancontract.component.html',
  styleUrls: ['./investmentloancontract.component.css']
})
export class InvestmentloancontractComponent implements OnInit { 
  @Input('parentRouteId') parentRouteId: any; 
  loan: any;
  loan_: any;
  currentUser: any;
  loading = false;
  constructor(private DataService: DataService,
    public toastr: ToastrService,public route: ActivatedRoute,
    public storageService: StorageService,
    public optionsService: OptionsserviceService,
    public loansService: LoansService,
    public operationsService: OperationsService,
    public dataService: DataService,
    public authService: AuthenticationService,
    public router: Router) { 
      this.currentUser = this.storageService.read<any>('currentUser');
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {  
      let change = changes[propName];
      
      let curVal  = JSON.stringify(change.currentValue);
      let prevVal = JSON.stringify(change.previousValue);
      //let changeLog = `${propName}: currentValue = ${curVal}, previousValue = ${prevVal}`;
      
      if (propName === 'parentRouteId') {
         this.loan = this.loan_;
         this.getLoan();
      }  
    }
  }
  ngOnInit() {
  }
  getLoan() { 
    this.loading = true;
    this.loansService.getLoanContractSimple(this.currentUser.token, this.parentRouteId)
      .subscribe(data => {
        this.loading = false;
        this.loan = data.loan;
        this.dataService.onRequestLoadingEndFromBackend.emit({loan:this.loan});
      });
  }
}
